import { Seo } from '../components/seo/Seo'
import { NO_ACCOUNT_PROMISE, PERMANENT_FILE_PROMISE } from '../data/siteCopy'

export function PrivacyPage() {
  return (
    <>
      <Seo route="/privacy/" />
      <section className="content-hero content-hero--privacy">
        <div className="shell shell--narrow">
          <p className="eyebrow">Privacy</p>
          <h1>{PERMANENT_FILE_PROMISE}</h1>
          <p className="content-hero__lede">Tool files and sensitive inputs are processed locally on your device.</p>
        </div>
      </section>
      <section className="prose-section">
        <div className="shell shell--narrow privacy-sections">
          <div className="privacy-callout">
            <span className="privacy-callout__mark" aria-hidden="true">✓</span>
            <div><h2>For local file and input tools</h2><p>Your selected images, PDFs, text, CSV, JSON, YAML, JWT, Base64, SQL, media, recordings, QR payloads, invoice details, calculator values, filenames, settings, metadata, and generated results are processed on your device and are not intentionally uploaded to an application server.</p></div>
          </div>
          <div>
            <h2>No account or sign-in</h2>
            <p>{NO_ACCOUNT_PROMISE} Public tools can be used without signing in, providing account credentials, or creating a StayInBrowser profile. This account-free access is separate from the browser-local processing described below.</p>
          </div>
          <div>
            <h2>For the Private Spending Tracker</h2>
            <p>Transactions, amounts, budgets, merchant names, account labels, notes, tags, imported CSV data, and backup contents are processed and stored in your browser on this device. The tracker does not upload those financial records to any server. Clearing browser or site data can remove local records, so you should keep your own backups.</p>
          </div>
          <div>
            <h2>Specialist decoders are local too</h2>
            <p>Image, PDF, OCR, data, and media routes download their JavaScript, WebAssembly, codec, model, or worker engines as ordinary website code only when needed. Your selected input is passed to that code in browser memory and is not uploaded to any server.</p>
          </div>
          <div>
            <h2>What the website still needs</h2>
            <p>Like any website, the application files themselves—HTML, CSS, and JavaScript—must be delivered to your browser by the web host. Normal hosting infrastructure may receive standard connection information such as an IP address and request headers.</p>
          </div>
          <div>
            <h2>Website analytics, no advertising, and no application backend</h2>
            <p>StayInBrowser currently uses Google Analytics 4 on the production website to measure ordinary website usage such as page visits. Analytics is disabled for local development and automated test sessions. The tools do not intentionally send selected files, file contents, pasted inputs, financial records, passwords, tokens, generated results, or other sensitive tool data to analytics. The site has no advertising integration or application backend.</p>
          </div>
          <div>
            <h2>Contact and feedback email</h2>
            <p>Contact and feedback links open your own email application. Information you deliberately include in a message is handled by your email provider and is separate from local tool processing.</p>
          </div>
          <div>
            <h2>The durable promise</h2>
            <p>Every public tool is designed so that selected files and sensitive tool inputs stay on your device. If hosting or other website infrastructure changes in the future, this page will distinguish those normal website requests from tool-file processing.</p>
          </div>
          <p className="last-updated">Last updated: August 14, 2026</p>
        </div>
      </section>
    </>
  )
}
